import { useState, useEffect } from "react";

const Nav = () => {

    const [theme, setTheme] = useState('light');

    useEffect(() => {
        if(theme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [theme]);

    const handleThemeToggle = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark');
    }

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);

        if(section) {
            section.scrollIntoView({behavior: 'smooth'});
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    const navs = ['Home', 'About', 'Work', 'Contacts']
    return (
        <div className="flex w-full fixed justify-center items-center z-50 576:w-[90%] ">
            <div className="drop-shadow-2xl flex items-center px-7 border border-solid border-black dark:border-gray-400 rounded-3xl bg-bgLight bg-opacity-95 shadow-lg 576:p-0 dark:bg-neutral-900 " style={{'backdrop-filter': 'blur(10px)', 'background': 'rgba(114,114,114,.2)'}}>
                {navs.map(nav => (
                    <span className='cursor-pointer text-black dark:text-white  px-5 py-1.5 text-lg hover:text-stone-400 dark:hover:text-custom-yellow transition duration-300 576:text-sm 576:py-1.5 576:px-2.5' onClick={() => scrollToSection(nav)}>{nav}</span>
                ))}
                <div>
                    <label className="w-11 h-11  grid cursor-pointer place-items-center" for="switch">
                        <input onClick={handleThemeToggle} id="switch" className="hidden peer/switch" type="checkbox"/>
                        <div className="col-span-full row-span-full transition duration-300 peer-checked/switch:rotate-[360deg] peer-checked/switch:scale-0">
                            <svg height="26" width="26" fill="yellow" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z"></path>
                            </svg>
                        </div>
                        <div className="col-span-full row-span-full transition duration-300 scale-0 peer-checked/switch:rotate-[360deg] peer-checked/switch:scale-100 peer-checked/switch:delay-100">
                            <svg height="26" width="26" fill="#5e757d" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path clip-rule="evenodd" d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z" fill-rule="evenodd"></path>
                            </svg>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
}

export default Nav;